module.exports = __webpack_public_path__ + "img/8.a2ffc725.png";